import React from "react";
import { Link } from "react-router-dom";

export const BRAND = {
  name: "SCHOKODALE – The Valley of Chocolates",
  email: "schokodale@gmail.com",
  phone: "+91 76229 27835",
  wa: "https://wa.me/917622927835",
  fssai: "20726048001065",
  updated: "June 2026",
};

const Mail = () => <a href={`mailto:${BRAND.email}`} className="text-[#D4AF37] hover:underline">{BRAND.email}</a>;
const Phone = () => <a href="tel:+917622927835" className="text-[#D4AF37] hover:underline">{BRAND.phone}</a>;

export const LegalLayout = ({ title, eyebrow = "Policies", testid, children }) => (
  <div data-testid={testid} className="max-w-4xl mx-auto px-4 sm:px-8 py-14">
    <span className="eyebrow">{eyebrow}</span>
    <h1 className="font-display text-4xl sm:text-5xl mt-3">{title}</h1>
    <p className="text-[#8C7B6E] text-xs mt-3">Last updated: {BRAND.updated}</p>
    <div className="legal-prose mt-10 space-y-8 text-[#C8B8AB] text-sm sm:text-base leading-relaxed">{children}</div>
    <div className="mt-14 pt-6 border-t border-[#3B251D] flex flex-wrap gap-x-6 gap-y-2 text-xs text-[#8C7B6E]">
      {POLICY_LINKS.map(([to, l]) => <Link key={to} to={to} className="hover:text-[#D4AF37]">{l}</Link>)}
    </div>
  </div>
);

export const POLICY_LINKS = [
  ["/privacy-policy", "Privacy Policy"], ["/terms-and-conditions", "Terms & Conditions"],
  ["/refund-cancellation", "Refund & Cancellation"], ["/shipping-delivery", "Shipping & Delivery"], ["/contact", "Contact Us"],
];

export const S = ({ h, children }) => (
  <section><h2 className="font-display text-xl sm:text-2xl text-[#FDFBF7] mb-3">{h}</h2><div className="space-y-3">{children}</div></section>
);
export const UL = ({ items }) => <ul className="list-disc pl-5 space-y-1.5">{items.map((t) => <li key={t}>{t}</li>)}</ul>;

export const CancellationTable = () => (
  <div className="lux-card overflow-hidden" data-testid="cancellation-table">
    <table className="w-full text-sm">
      <thead className="bg-[#1A0F0B] text-[#8C7B6E] text-xs uppercase"><tr><th className="text-left p-4">When you cancel (from order time)</th><th className="text-left p-4">Cancellation charge</th><th className="text-left p-4">Amount returned</th></tr></thead>
      <tbody>
        {[["Within 6 hours", "Nil — free cancellation", "100% of amount paid"], ["After 6 hours, up to 24 hours", "25% of order value", "75% of amount paid"], ["After 24 hours (before dispatch)", "50% of order value", "50% of amount paid"], ["After dispatch", "Cancellation not possible", "—"]].map((r) => (
          <tr key={r[0]} className="border-t border-[#3B251D]">{r.map((c, i) => <td key={`${r[0]}-${c}`} className={`p-4 ${i === 0 ? "text-[#FDFBF7]" : ""}`}>{c}</td>)}</tr>
        ))}
      </tbody>
    </table>
  </div>
);

export { Mail, Phone };
